export default {"src":"/_next/static/media/rutabaga.d85768db.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};